import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-514fcc2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = ["onClick"]

import { ref } from 'vue';
import { debounce } from 'lodash';
import { useScroll } from '@vueuse/core';
import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';

interface Props {
  sticky: boolean;
  activeMenuIndex: number;
  menus: {
    name: string;
    disabled?: boolean;
    key?: string;
  }[];
}

interface Emits {
  (event: 'menu-click', menu: Props['menus'][number]): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    sticky: { type: Boolean },
    activeMenuIndex: null,
    menus: null
  },
  emits: ["menu-click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'menu-click', menu: Props['menus'][number]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sticky: boolean;
  activeMenuIndex: number;
  menus: {
    name: string;
    disabled?: boolean;
    key?: string;
  }[];
}




const navbarRef = ref<HTMLDivElement>();
const menuItemScrollIntoView = debounce(() => {
  if (props.sticky) {
    if (window.innerWidth > 768) {
      return;
    }
  }
}, 50);

useScroll(window, {
  onStop() {
    menuItemScrollIntoView();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "navbarRef",
    ref: navbarRef,
    class: _normalizeClass(["s5-navbar relative font-Pretendar", { sticky: __props.sticky }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus.filter(elm => elm.key == 'apply'), (item, index) => {
      return (_openBlock(), _createBlock(ColaButton, {
        key: item.name,
        class: _normalizeClass(["action-menu-button", [`menu-${index}`, { active: index === __props.activeMenuIndex, disabled: item.disabled }]]),
        border: true,
        title: item.name,
        "small-icon": true,
        onClick: ($event: any) => (emits('menu-click', item))
      }, null, 8, ["class", "title", "onClick"]))
    }), 128)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menus.filter(elm => elm.key != 'apply'), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.name,
          class: _normalizeClass(["menu", [`menu-${index}`, { active: index === __props.activeMenuIndex, disabled: item.disabled }]]),
          onClick: ($event: any) => (emits('menu-click', item))
        }, _toDisplayString(item.name), 11, _hoisted_2))
      }), 128))
    ])
  ], 2))
}
}

})